/** Stable cache token for an array filter — undefined / empty collapse to "". */
export function filterToken(values: string[] | undefined): string {
  if (!values || values.length === 0) return "";
  return values.join(",");
}
